import script from "./SliderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderSection.vue?vue&type=script&setup=true&lang=js"

import "./SliderSection.vue?vue&type=style&index=0&id=6f490e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f490e7a"]])

export default __exports__